import { axiosInstance } from './common';

export const listWorkspaces = () =>
  axiosInstance.get('/workspace/list').then((response) => response.data);

export const getWorkspace = (id) =>
  axiosInstance.get(`/workspace/${id}`).then((response) => response.data);

export const createWorkspace = (name, description) =>
  axiosInstance.post('/workspace', { name, description }).then((response) => response.data);

export const updateWorkspace = (id, name, description) =>
  axiosInstance.put(`/workspace/${id}`, { name, description }).then((response) => response.data);

export const updateLayout = (id, layoutConfig) =>
  axiosInstance.put(`/workspace/${id}/layout`, layoutConfig).then((response) => response.data);

export const addRecording = (id, recordingId) =>
  axiosInstance.post(`/workspace/${id}/recordings`, { recordingId }).then((response) => response.data);

export const removeRecording = (id, recordingId) =>
  axiosInstance.delete(`/workspace/${id}/recordings/${recordingId}`).then((response) => response.data);

export const updateNotes = (id, notes) =>
  axiosInstance.put(`/workspace/${id}/notes`, { notes }).then((response) => response.data);

export const updateTimelineMarkers = (id, markers) =>
  axiosInstance.put(`/workspace/${id}/timeline-markers`, markers).then((response) => response.data);

export const updateRecordingMetadata = (id, recordingMetadata) =>
  axiosInstance.put(`/workspace/${id}/recording-metadata`, recordingMetadata).then((response) => response.data);

export const deleteWorkspace = (id) =>
  axiosInstance.delete(`/workspace/${id}`).then((response) => response.data);
